module.exports = __webpack_public_path__ + "googleAuth_ico@2x.ff734a24b58ba2351fa7c09b33a4f1f8.png";